import {
  AssetsGetOrderByEndTimeEnum,
  AssetsGetOrderByNameEnum,
  AssetsGetOrderByStartTimeEnum,
  AssetsGetRequest,
} from '@nativewaves/nw-cloud-sdk/media'
import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Assets'
import { mediaPlatformRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Assets'

export const mediaPlatformAssetsRoute = createRoute({
  getParentRoute: () => mediaPlatformRoute,
  path: StaticRouteParameter.ASSETS,
  loader: () => ({
    crumb: t('entity:publishing.asset', { count: 2 }),
  }),
})

export const mediaPlatformAssetsLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformAssetsRoute,
  id: 'mediaPlatformAssetsLayout',
  component: Structure,
})

type MediaPlatformAssetsOverviewSearch = {
  query?: string
  idOrNameSearch?: boolean
} & Partial<PickStartsWith<AssetsGetRequest, 'orderBy'>>

const sortProperties = ['orderByName', 'orderByStartTime', 'orderByEndTime'] as const satisfies (keyof PickStartsWith<
  AssetsGetRequest,
  'orderBy'
>)[]

const sortPropertyValues = new Map<keyof PickStartsWith<AssetsGetRequest, 'orderBy'>, Record<string, string>>([
  ['orderByName', AssetsGetOrderByNameEnum],
  ['orderByStartTime', AssetsGetOrderByStartTimeEnum],
  ['orderByEndTime', AssetsGetOrderByEndTimeEnum],
])

export const mediaPlatformAssetsOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformAssetsLayoutRoute,
  path: '/',
  component: Overview,
  validateSearch: (search: Record<string, unknown>): MediaPlatformAssetsOverviewSearch => {
    const result: Record<string, unknown> = {}

    if (search.query && typeof search.query === 'string' && !!search.query.length) {
      result.query = search.query
    }

    if (search.idOrNameSearch && typeof search.idOrNameSearch === 'boolean') {
      result.idOrNameSearch = search.idOrNameSearch
    }

    if (search.timeRangeStart && typeof search.timeRangeStart === 'number' && !isNaN(search.timeRangeStart)) {
      result.timeRangeStart = search.timeRangeStart
    }

    if (search.timeRangeEnd && typeof search.timeRangeEnd === 'number' && !isNaN(search.timeRangeEnd)) {
      result.timeRangeEnd = search.timeRangeEnd
    }

    for (const sortProperty of sortProperties) {
      if (
        search[sortProperty] &&
        typeof search[sortProperty] === 'string' &&
        search[sortProperty] in sortPropertyValues.get(sortProperty)!
      ) {
        result[sortProperty] = search[sortProperty]
      }
    }

    return result satisfies MediaPlatformAssetsOverviewSearch
  },
})
